import React, { Component, Fragment, Children } from 'react'
import ReactDOM from 'react-dom'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import StyleSheet from 'styles/StyleSheet'
import { debounce } from 'utils'
export class Carousel extends Component{

  constructor(props){
    super(props)
    this.children = []
  }

  state = {
    index: 0,
    children: []
  }

  static defaultProps = {
    showNavArrows: true,
    autoScrollEvery: null,
    navDotColor: '#FFF'
  }

  componentDidMount(){
    window.addEventListener('resize', this.refresh)
    setTimeout(this.refresh, 500)

  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.refresh)
    clearInterval(this.autoScroller)
  }

  initScroller = () => {
     clearInterval(this.autoScroller)
    if(this.props.autoScrollEvery){
      this.autoScroller = setInterval(this.slide(1), this.props.autoScrollEvery)
    }
  }

  refresh = debounce(() =>
    this.forceUpdate()
  )

  get marginLeft(){
    try{
      const child  = this.children[this.state.index]
      const parent = child.parentElement
      return child.offsetLeft - parent.offsetLeft
    }catch(err){
      return 0
    }
  }

  get shouldShowNavArrows(){
    let childrenOnScreen = false
    try{
      if(this.children.length){
        const margin = 20
        var firstChild = this.children[0]
        var lastChild = this.children[this.children.length - 1]
        var parent = firstChild.parentElement
        childrenOnScreen =  (firstChild.offsetLeft + margin >= 0) && (lastChild.offsetLeft + lastChild.offsetWidth <= parent.offsetWidth + margin)
      }
    }
    catch(_){

    }
    return this.props.showNavArrows && !childrenOnScreen
  }

  setRef = i => ref => {
    this.children[i] = ReactDOM.findDOMNode(ref)
  }

  renderChild = ({type: Type, props}, i) => {
    return <Type ref={this.setRef(i)} {...props}/>
  }

  renderNavDots = () =>
    <div className={styles.navDots}>
      {
        this.children.map((child, index) =>
          <div
            style={{backgroundColor: this.props.navDotColor}}
            className={styles.navDot}
            key={index}
            onClick={() => this.setState({index})}
          />
        )
      }
    </div>

  slide = direction => () => {
    if(!this.children.length)
      return
    this.initScroller()
    if(direction === 1){
      const child     = this.children[this.state.index]
      const parent    = child.parentElement
      const wrapper   = parent.parentElement
      const lastChild = this.children[this.children.length - 1]
      if((lastChild.offsetLeft + lastChild.offsetWidth - 20) < wrapper.offsetLeft + wrapper.offsetWidth){
        this.setState({index: 0})
        return
      }
    }
    this.setState({
      index:
        (((this.state.index + direction) % this.children.length) + this.children.length) % this.children.length
    })
  }

  render = () =>
    <div className={`${styles.carouselWrapper} ${this.props.wrapperClassName}`}>
      { this.shouldShowNavArrows && this.state.index !== 0 &&
        <div className={styles('nav', 'navLeft')} onClick={this.slide(-1)}>
          <ChevronLeftIcon style={{width: 30, height: 30, color: 'white'}}/>
        </div>
      }
      <div style={{marginLeft: `-${this.marginLeft}px`}} className={`${this.props.className} ${styles.carouselInner}`}>
        {Children.map(this.props.children, this.renderChild)}
      </div>
      { this.shouldShowNavArrows && this.state.index !== this.children.length - 1 &&
        <div className={styles('nav', 'navRight')} onClick={this.slide(1)}>
          <ChevronRightIcon style={{width: 30, height: 30, color: 'white'}}/>
        </div>
      }
      {
        this.props.showNavDots && this.renderNavDots() }
    </div>

}

export class CarouselItem extends Component{
  render = () =>
    <Fragment>
      {this.props.children}
    </Fragment>

}

const styles = StyleSheet({
  carouselWrapper: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
  },
  carouselInner: {
    transition: 'margin 1.0s ease',
    width: '100%',
    overflow: 'visible'
  },
  nav: {
    top: 0,
    cursor: 'pointer',
    position: 'absolute',
    width: 20,
    height: '100%',
    background: 'rgba(0, 0, 0, 0.05)',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.3)'
    }
  },
  navLeft: {
    left: 0,
    '& svg':{
      marginLeft: -10
    }
  },
  navRight: {
    right: 0
  },
  navDots: {
    height: 30,
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    display: 'flex',
    justifyContent:' center',
  },
  navDot: {
    flex: '0 1 auto',
    borderRadius: 10,
    width: 10,
    height: 10,
    margin: 10,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7
    }
  }
})

export default Carousel